const numberFormat = {
    format: (number, digits) => {
        return new Intl.NumberFormat('en-US', { style: "decimal", minimumFractionDigits: digits || 0, maximumFractionDigits: digits || 2 }).format(number);
    },
    percent: (number, digits) => {
        return new Intl.NumberFormat('en-US', { style: "percent", minimumFractionDigits: digits || 0, maximumFractionDigits: digits || 2 }).format(number);
    },
    compact: (number, digits) => {
        return new Intl.NumberFormat('en-US', { notation: 'compact', minimumFractionDigits: digits || 0, maximumFractionDigits: digits || 1 }).format(number);
    }
};
export default numberFormat;
